import { Formik } from "formik";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

export type LinkData = {
  linkTitle?: string;
  linkContent?: string;
  linkUrl?: string;
  row?: any;
};

interface EditDocumentLinkProps {
  onClose: () => void;
  onLinkSubmit: (linkdata: LinkData) => void;
  isOpen: boolean;
  linkModalData: LinkData;
}

export const EditDocumentLinkModal = ({ isOpen, onClose, linkModalData, onLinkSubmit }: EditDocumentLinkProps) => {
    
  const copyContent = (linkData: LinkData) => {
    const linkElement = document.createElement("a");
    linkElement.setAttribute("href", linkData.linkUrl || "");
    linkElement.setAttribute("title", linkData.linkContent || "");
    linkElement.setAttribute("target", "_blank");
    linkElement.setAttribute("id", linkData.row.data.Id);
    linkElement.setAttribute("class", linkData.row.data.numberEdit);
    linkElement.textContent = linkData.linkTitle || "";
    navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([linkElement.outerHTML], { type: "text/html" }),
      }),
    ]);
  };

  const handleOnSubmit = async (values: LinkData) => {
    copyContent(values);
    onClose();
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered size={"lg"} className="add-folder-modal">
      <Formik
        // validationSchema={addUrlLinkValidationSchema}
        onSubmit={handleOnSubmit}
        initialValues={{
          linkTitle: linkModalData.linkTitle ? linkModalData.linkTitle : "",
          linkContent: linkModalData.linkContent ? linkModalData.linkContent : "",
          linkUrl: linkModalData.linkUrl ? linkModalData.linkUrl : "",
          row: linkModalData.row || {},
        }}
      >
        {({ handleSubmit, handleChange, values, errors }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Sao chép liên kết đoạn văn bản</Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-2 px-4">
              <Form.Group as={Row}>
                <Form.Label column sm={2} className="card-label px-1">
                  Nội dung hiển thị
                </Form.Label>
                <Col sm={10} className="px-1">
                  <Form.Control
                    required
                    type="text"
                    name="linkTitle"
                    value={values.linkTitle}
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={2} className="card-label px-1">
                  Nội dung đoạn
                </Form.Label>
                <Col sm={10} className="px-1">
                  <Form.Control
                    required
                    type="text"
                    name="linkContent"
                    value={values.linkContent}
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={2} className="card-label px-1">
                  Đường dẫn
                </Form.Label>
                <Col sm={10} className="px-1">
                  <Form.Control required type="text" name="linkUrl" value={values.linkUrl} onChange={handleChange} />
                </Col>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={onClose} variant="secondary">
                Hủy
              </Button>
              <Button type="submit" variant="info">
                Sao chép
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
